import LinkContainer from 'containers/LinkContainer'

export default LinkContainer
